import Marionette from "backbone.marionette";
import { DisplayCollectionItemView } from "./DisplayCollectionItemView";

export const DisplayCollectionView = Marionette.CollectionView.extend({
    tagName: "ul",
    className: "DisplayCollectionView list-group",

    childView: DisplayCollectionItemView
});


// WEBPACK FOOTER //
// ./src/js/view/components/DisplayCollectionView.js